import React from "react";
import { Link } from "react-router-dom";

export function ServiceCTA() {
  return (
    <section className="relative overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-gray-900 via-primary-900 to-gray-900" />
      
      {/* Decorative elements */}
      <div className="absolute inset-x-0 inset-y-0 bg-gradient-to-b from-white/5 to-transparent" />
      <div className="absolute bottom-0 left-1/2 h-96 w-96 -translate-x-1/2 translate-y-1/2 transform rounded-full bg-primary/30 blur-3xl" />
      
      <div className="relative mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Ready to Transform Your Enterprise with AI?
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-lg leading-8 text-gray-300">
            Let's discuss how we can help you integrate advanced AI capabilities into your
            organization using Microsoft's latest technologies.
          </p>
          <div className="mt-10 flex items-center justify-center gap-6">
            <Link
              to="/contact?type=consulting"
              className="rounded-md bg-primary px-8 py-4 text-base font-semibold text-white shadow-sm hover:bg-primary/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
            >
              Schedule a Consultation
            </Link>
            <a
              href="/about"
              className="text-base font-semibold leading-7 text-white hover:text-gray-300"
            >
              Learn more <span aria-hidden="true">→</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
